// src/MainPage.js
import React, { useEffect, useState } from 'react';
import SectionWrapper from './components/SectionWrapper';
import AboutSection from './components/AboutSection';
import SkillsSection from './components/SkillsSection';
import Timeline from './components/Timeline';
import LanguagesSection from './components/LanguagesSection';
import ContactSection from './components/ContactSection';
import BlochSphere from './components/BlochSphere';
import QuantumEquations from './components/QuantumEquations';
import Navbar from './components/Navbar';
import { ThemeProvider } from './components/ThemeContext'; // ✅ IMPORT
import './MainPage.css';

export default function MainPage() {
  const [isScrolling, setIsScrolling] = useState(false);
  const [direction, setDirection] = useState({ theta: 0, phi: 0 });

  useEffect(() => {
    let scrollTimeout;
    const handleScroll = () => {
      setIsScrolling(true);
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        setIsScrolling(false);
      }, 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ThemeProvider> {/* ✅ WRAP EVERYTHING */}
      <Navbar />
      <div className="mainpage-container">
        <QuantumEquations isScrolling={isScrolling} />
        <BlochSphere isScrolling={isScrolling} direction={direction} />

        <div id="about"><AboutSection /></div>
        <SectionWrapper index={1}><div id="skills"><SkillsSection /></div></SectionWrapper>
        <SectionWrapper index={2}><div id="timeline"><Timeline /></div></SectionWrapper>
        <SectionWrapper index={3}><div id="languages"><LanguagesSection /></div></SectionWrapper>
        <SectionWrapper index={4}><div id="contact"><ContactSection /></div></SectionWrapper>
      </div>
    </ThemeProvider>
  );
}
